/**
 * Shared error-message element for form controls (Input, Select, Textarea,
 * Combobox, Checkbox). Renders nothing when `error` is falsy. Always visible
 * and in normal flow - never `sr-only` or absolutely positioned - so the
 * field grows in place rather than announcing an error the user cannot see.
 */
export function FieldError({ id, error }: { id: string; error?: string }) {
  if (!error) return null;

  return (
    <p id={id} role="alert" className="text-xs text-error">
      {error}
    </p>
  );
}
